<template>
  <div v-if="!AreIdsShown">
    <div v-if="userStore.isAuthenticated" class="layout">
      <!-- userStore.isAuthenticated {{ userStore.isAuthenticated }} -->
      <!-- <Landing /> -->
      <!-- <div class="flex-container">
        <div class="content">
          <RouterView />
        </div>
      </div> -->

      <!-- <h1>CONSOLE</h1> -->
      <b-tabs fill content-class="mt-0" :class="modalTheme" style="margin: 6px 10px 6px 10px">
        <b-tab title="Home" active> <Landing /> </b-tab>
        <b-tab title="Physicians Console"> <PhysiciansConsole /> </b-tab>
        <b-tab title="Admin"> <Admin /> </b-tab>
        <b-tab title="Patient Portal">
          <!-- PP -->
          <c />
        </b-tab>
        <b-tab title="c">
          <!-- bills -->
          <Billing />
        </b-tab>
        <b-tab title="NOC">
          <!-- NOC -->
          <NOC />
        </b-tab>
      </b-tabs>
    </div>
    <div v-else>
      <Landing />
    </div>
  </div>

  <div v-if="AreIdsShown">
    <div v-if="userStore.isAuthenticated" class="layout">
      <b-nav justified style="background: transparent; padding: 3px; height: 25px; font-size: 10pt" :class="modalTheme">
        <!-- <b-nav-item active-class="worklists-active" to="/landing">Landing</b-nav-item> -->
        <b-nav-item active-class="worklists-active" to="/emr">Physicians Console</b-nav-item>

        <b-nav-item to="/scheduler">Scheduler</b-nav-item>

        <b-nav-item active-class="worklists-active" to="/Admin">Admin</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/PatientPortal">PatientPortal</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/Billing">Billing</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/NOC">NOC</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/announcements">Announcements</b-nav-item>

        <!-- <b-nav-item active-class="worklists-active" to="/Dashboard/Primary">Dashboard</b-nav-item> -->
        <!--
        <b-nav-item to="/scheduler">Scheduler</b-nav-item>

        <b-nav-item active-class="worklists-active" to="/patients">Patients</b-nav-item>

        <b-nav-item active-class="worklists-active" to="/Reporting" v-show="hasFullPatientChart">Reporting</b-nav-item>

        <b-nav-item active-class="worklists-active" to="/NIHCodeLookup">Code Lookup</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/announcements">Announcements</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/blank">BLANK DEV</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/masterPatientList">MASTER</b-nav-item>

        <b-nav-item active-class="worklists-active" v-show="showHCC" :to="{ path: HCCUrl }">Plan</b-nav-item> -->
      </b-nav>

      <div class="tab-content" :class="modalTheme">
        <RouterView />
      </div>
    </div>
    <div v-else>
      <Landing />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// & ROUTER
import { RouterLink, RouterView, useRoute, useRouter } from "vue-router";

import config from "devextreme/core/config";
import { licenseKey } from "./devextreme-license";

config({ licenseKey });

import { getToken } from "@/config/authService";

// * STORE
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import themes, { init } from "devextreme/ui/themes";
init(); // Initialize themes if needed
const savedTheme = localStorage.getItem("dx-theme") || "generic.light.white";

// & COMPOSIBLEs
import { initializeTheme } from "@/use/themeUtils.js";
initializeTheme();

import UserProfile from "@/modules/User/UserProfile.vue";

import PhysiciansConsole from "./PhysiciansConsole.vue";
import Admin from "./Admin.vue";
import PatientPortal from "./PatientPortal.vue";
import Billing from "./Billing.vue";
import NOC from "./NOC.vue";
import Landing from "./views/Landing.vue";

const AreIdsShown = ref(true);

const modalTheme = computed(() => userStore.bModalTheme);

onMounted(async () => {
  // console.log("onMounted() :      CONSOLE APP  >>>>");

  // console.log("  CONSOLE       themes ccheck        *");
  // console.log(themes.current());
  try {
    // Attempt silent login on component mount
    // console.log(" APP mount:  getToken()  REQUIRED to cycle past LANDING >>>>>>");
    const token = await getToken();
    if (token) {
      // console.log(" >>>>>>>>>>>>>>>>>>>>>>>                                                        [TheWelcome.vue] Silent login successful, token:   FOUND");
      // // console.log(" >>>>>>>>>>>>>>>>>>>>>>>                                                        [TheWelcome.vue] Silent login successful, token:", token);
      //await getUserData(); // Only call if authenticated
    }
  } catch (e) {
    // console.log("                    Silent login failed:", e);
    // Optionally, handle errors or show a message
  }
});
</script>
<style lang="scss">
// @import "@/assets/css/main.scss";
</style>
